import React, { useState } from 'react';
import { Track } from '../data/musicData';
import '../styles/MusicCard.css';

interface MusicCardProps {
  track: Track;
}

const MusicCard: React.FC<MusicCardProps> = ({ track }) => {
  const [isPlaying, setIsPlaying] = useState(false);

  const togglePlay = () => {
    setIsPlaying(!isPlaying);
  };

  return (
    <div className="music-card">
      <div className="music-cover">
        <img src={track.coverArt || '/api/placeholder/300/300'} alt={track.title} />
        <button className="play-button" onClick={togglePlay}>
          {isPlaying ? '⏸' : '▶'}
        </button>
      </div>
      <div className="music-info">
        <h3>{track.title}</h3>
        <p className="music-artist">{track.artist}</p>
        <p className="music-album">{track.album}</p>
        <p className="music-year">{track.year}</p>
        <div className="music-tags">
          {track.genre.map((g, index) => (
            <span key={index} className="genre-tag">{g}</span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MusicCard;